import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

import Loader from './Loader';
import Interstitial from './Interstitial';

export class InterstitialLoader extends Component {
  static propTypes = {
    loader: PropTypes.object,
    type: PropTypes.string
  };

  render() {
    const { t, type } = this.props;
    const loadingText = type === 'applications' ? t('interstitial_loader.loading_applications') : t('interstitial_loader.loading_page');
    return (
      <div className="common-interstitial-loader">
        <Interstitial>
          <Loader {...this.props.loader} />
          <h1 className="mt-5">{loadingText}</h1>
        </Interstitial>
      </div>
    );
  }
}

export default withNamespaces('common')(InterstitialLoader);



// WEBPACK FOOTER //
// ./src/features/common/InterstitialLoader.js